import { landingTrackerServiceModule } from '../../services/landing-tracker-service';
import { scrollToComponentModule } from '../../../../shared/app/components/scroll-to/scroll-to';
import { scrollOnFocusDirectiveModule } from '../../../../shared/app/components/scroll-on-focus/scroll-on-focus';
import { uniqueEmailValidatorComponentModule } from '../../../../shared/app/components/forms/unique-email-validator/unique-email-validator';
import { btnCtaDirectiveModule } from '../btn-cta/btn-cta';
import { elasticComponentModule } from '../../../../shared/app/vendor/elastic-component-module';
import { utmProps } from '../../../../shared/app/utils/utm-tracking-utils/utm-tracking-utils';

const DATA_MAP = {
  firstName: 'contactFirstName',
  lastName: 'contactLastName',
  email: 'contactEmail',
  title: 'contactTitle',
};

const formData = {
  firstName: '',
  lastName: '',
  email: '',
  title: '',
};

export const salesLeadData = () => {
  let data = null;
  try {
    if (window.sessionStorage && window.sessionStorage.qSalesLead) {
      data = JSON.parse(window.sessionStorage.qSalesLead);
    }
  } catch (err) {}
  return data || {};
};

Object.assign(formData, salesLeadData());

export const salesLeadFormComponentModule = angular
  .module('Q.components.sales-lead-form', [
    landingTrackerServiceModule,
    uniqueEmailValidatorComponentModule,
    scrollToComponentModule,
    scrollOnFocusDirectiveModule,
    btnCtaDirectiveModule,
    elasticComponentModule,
  ])

  .directive(
    'salesLeadForm',
    function ($http, trackerService, $document, $window, scrollToElement) {
      return function (scope) {
        const ctrl = {};
        scope.$ctrl = ctrl;

        ctrl.disabled = false;
        ctrl.data = formData;

        ctrl.supportEmailHref = () => {
          const subject = encodeURIComponent('Signup help');
          const body = encodeURIComponent(
            `Hello, I'm trying to sign up with ${formData.email}!`,
          );
          return `mailto:support@qualified.io?subject=${subject}&body=${body}`;
        };

        let possibleStudent = true;
        ctrl.checkEducation = () => {
          if (possibleStudent) {
            ctrl.showEducationWarning =
              /@.+\.edu$/i.test(formData.email) ||
              /student/i.test(formData.title);
          }
        };
        ctrl.setNotStudent = () => {
          possibleStudent = false;
          ctrl.showEducationWarning = false;
        };

        ctrl.saveSalesLeadData = () => {
          try {
            if (window.sessionStorage) {
              window.sessionStorage.qSalesLead = JSON.stringify(formData);
            }
          } catch (err) {}
          return true;
        };

        ctrl.submit = () => {
          ctrl.disabled = true;
          ctrl.saveSalesLeadData();
          let data = angular.merge({ type: 'freetrial' }, formData, {
            marketing: utmProps,
          });
          angular.forEach(DATA_MAP, (to, from) => {
            data[to] = data[from];
            delete data[from];
          });
          trackerService.trackEvent(`landing.salesLead.freetrial.submit`, data);
          $http
            .post('/api/v1/sales_leads/', { data })
            .then(() => {
              trackerService.trackEvent(
                `landing.salesLead.freetrial.success`,
                data,
              );
              $window.location = '/signup-success';
            })
            .catch(() => {
              ctrl.error = true;
              trackerService.trackEvent(
                `landing.salesLead.freetrial.error`,
                data,
              );
            })
            .finally(() => {
              ctrl.disabled = false;
              scrollToElement({ target: '#signup' });
            });
        };
      };
    },
  );
